import "styles/landing-pages/marketing.less";
import { useContext, useState } from "react";

import { AppContext } from "App";
import ButtonFooter from "components/basic/Footer/ButtonFooter";
import Header from "components/basic/Header/Header";

import Footer from "../../basic/Footer/Footer";
import HowItWorks from "../Home/components/HowItWorks";
import Main from "../Home/components/Main";
import WeHelped from "../Home/components/WeHelped";
import Reviews from "../Reviews/Reviews";

const Marketing = () => {
    const { maxWidth } = useContext(AppContext);
    const [showButtonFooter, setShowButtonFooter] = useState(false);

    return (
        <div className="marketing">
            <Header/>
            <div style={{ maxWidth: maxWidth, margin: "0 auto" }}>
                <Main setShowButtonFooter={setShowButtonFooter}/>
                <div className={"horizontal-center"} id="marketingStartButton">
                    <div id="marketingStartButton">

                        <video controls autoPlay muted loop playsInline className={"marketing__video mb20"}>
                            <source src={"https://taxzap-videos.s3.eu-west-1.amazonaws.com/taxzap_marketing_video.mp4"} type="video/mp4"/>
                            Your browser does not support the video tag.
                        </video>

                    </div>
                </div>
                <div id={"how-it-works"}>
                    <HowItWorks/>

                    <WeHelped/>

                    <Reviews/>
                </div>
            </div>
            <div id={"contact"}>
                <Footer/>
            </div>
            <ButtonFooter showButtonFooter={showButtonFooter}/>
        </div>
    );
};

export default Marketing;
